import { List } from './List';
import { ReachAPI } from '../ReachApi';
import { glom } from '../Signage/glom';
import { DataList, ListMetadata } from './types';
import { Cell } from './Cell';

/**
 * Create a data list
 */
function createList(
    listId: string,
    limit?: number,
    showMissingRows?: boolean,
    cellRange?: string | null
): Promise<List> {
    limit = limit || 1;
    showMissingRows = showMissingRows || false;
    cellRange = cellRange || '1:';

    return getList(listId, limit, showMissingRows, cellRange, null);
}

/**
 * Retrieve and create list
 */
async function getList(
    listId: string,
    limit: number,
    showMissingRows: boolean,
    cellRange: string,
    parentList: List | null
): Promise<List> {
    const apiSecurity = new ReachAPI.Security(glom.playerUuid, glom.securityToken);

    return ReachAPI.signage
        .getList(listId, cellRange, showMissingRows, apiSecurity)
        .then((listData: DataList) => {
            return initializeList(showMissingRows, cellRange, parentList, limit, listData);
        });
}

/**
 * Initialize list to prescribed depth limit
 */
async function initializeList(
    showMissingRows: boolean,
    cellRange: string,
    parentList: List | null,
    limit: number,
    listData: DataList
): Promise<List> {
    limit--;
    let listPromises: Array<Promise<List | void>> = [];
    const listMetaData: ListMetadata = {
        id: listData.list.id,
        data_list_name: listData.list.data_list_name,
        data_list_type: listData.list.data_list_type,
        columns: listData.columns,
    };
    const newList = new List(listMetaData, listData.rows, parentList);

    const ownListCells = newList.getListCells();
    if (limit > 0) {
        listPromises = ownListCells.map(function (cell: Cell) {
            let cellId: string | null = null;
            if (cell.value && typeof cell.value !== 'string') {
                if (cell.value instanceof List) {
                    cellId = cell.value.ID;
                }
            }

            if (!cellId) {
                throw new Error('Invalid data list cell value');
            } else {
                return getList(cellId, limit, showMissingRows, cellRange, newList).then(function (
                    list
                ) {
                    cell.value = list;
                });
            }
        });
    }

    return Promise.all(listPromises).then(function () {
        return newList;
    });
}

export { createList };
